import { get } from '@vueuse/core';
export default defineNuxtPlugin(() => {
  const { userAuthData } = useUserAuth()
  useBugsnag().setUser(get(userAuthData)?.user?._id, get(userAuthData)?.user?.email,  get(userAuthData)?.entity?.name)
  useBugsnag().addMetadata('company', { name:  get(userAuthData)?.entity?.consumer_id ?? 'dev' })

});
